import { fg } from '@atlassian/jira-feature-gating';

export default {
	get(): boolean {
		return fg('goal_group_header_smart_link_relay');
	},
};
